import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import theme from "./theme.ts";
import {ThemeProvider} from '@mui/material/styles';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App.tsx';
import Research from './Pages/Research.tsx'
import Bio from './Pages/Bio.tsx'
import { BucketListHome } from './BucketList/Home.tsx'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/research" element={<Research />} />
          <Route path="/bio" element={<Bio />} />
          <Route path="/bucket-list" element={<BucketListHome />} />
          
        </Routes>
      </ThemeProvider>
    </React.StrictMode>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
